module.exports = __webpack_public_path__ + "static/media/c.e9c7b703.jpg";